// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2fRGq","vLegacy":"SelectSecondary_vLegacy__2CpGK","error":"SelectSecondary_error__34pKE","disabled":"SelectSecondary_disabled__JEcrB"};